export enum EwxProviderType {
  PROVIDER = 1,
  STAFF = 2,
}
